<script>
import { cn } from "$lib/utils";

let className = "";
export { className as class };
const _class = cn("size-4", "shrink-0", className);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.4"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-label="Image icon"
  class={_class}
  {...$$restProps}
  ><rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect><circle cx="9" cy="9" r="2"></circle><path
    d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
  ></path></svg
>
